module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "lay00er-1-1.a3a9fc6c.png";